import { GALLERY_CATEGORIES } from '@lib/constants';
import Icon from '@components/common/Icon';

const GalleryFilterSection = ({ activeFilter, setActiveFilter }) => {
  return (
    <section className="py-8 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <div className="container mx-auto max-w-7xl">
        {/* Mobile: horizontal scroll, Desktop: flex-wrap center */}
        <div className="flex md:flex-wrap gap-3 md:justify-center overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-2 md:pb-0 -mx-4 px-4 md:mx-0">
          {GALLERY_CATEGORIES.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveFilter(category.id)}
              className="inline-flex items-center gap-2 px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg font-medium transition-all duration-200 flex-shrink-0 snap-center whitespace-nowrap"
              style={{
                backgroundColor: activeFilter === category.id
                  ? 'var(--color-button-primary-bg)'
                  : 'var(--color-card-bg)',
                color: activeFilter === category.id
                  ? 'var(--color-button-primary-text)'
                  : 'var(--color-card-text)',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: activeFilter === category.id
                  ? 'var(--color-button-primary-bg)'
                  : 'var(--color-card-border)',
                boxShadow: activeFilter === category.id
                  ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                  : 'none',
                transform: activeFilter === category.id ? 'translateY(-1px)' : 'none',
              }}
              onMouseEnter={(e) => {
                if (activeFilter !== category.id) {
                  e.currentTarget.style.borderColor = 'var(--color-card-hover-border)';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }
              }}
              onMouseLeave={(e) => {
                if (activeFilter !== category.id) {
                  e.currentTarget.style.borderColor = 'var(--color-card-border)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }
              }}
            >
              <Icon
                name={category.icon}
                size="sm"
                style={{
                  color: activeFilter === category.id
                    ? 'var(--color-button-primary-text)'
                    : 'var(--color-icon-default)'
                }}
              />
              <span>{category.label}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryFilterSection;
